import { render, staticRenderFns } from "./OfferGoodsAndServices.vue?vue&type=template&id=7da4e9be&"
import script from "./OfferGoodsAndServices.vue?vue&type=script&lang=ts&"
export * from "./OfferGoodsAndServices.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports